<ion-label class="text-[13px] pl-5" color="secondary" *ngIf="field.visible">{{ field.label | translate }}
  <span *ngIf="field.required" class="text-danger">*</span>
</ion-label>

<div *ngIf="
    field &&
    inputControl &&
    field.type !== 'file' &&
    field.type !== 'map' &&
    field.type !== 'boolean' &&
    field.visible
  " class="rounded-[19px] py-[15px] px-[25px] overflow-hidden flex items-center gap-3 mt-2 bg-[#ebf6fb80]"
     [ngStyle]="{ height: field.type === 'textarea' ? 'auto' : '46px' }" [class]="invalid ? 'error' : ''">
  <!-- INPUT TEXT -->
  <ion-input *ngIf="field.type === 'text' && field.formControlName !== 'value'" mode="ios"
             [placeholder]="field.placeholder | translate" [type]="field.type"
             [formControl]="inputControl" [maskito]="setMask(field.formControlName)"
             (ionInput)="applyMask($event.target.value)">
  </ion-input>
  <!-- INPUT VALUE (moneda € con formateo en blur) -->
  <ion-input *ngIf="field.type === 'text' && field.formControlName === 'value'"
             mode="ios"
             [placeholder]="field.placeholder | translate"
             type="text"
             inputmode="decimal"
             [formControl]="inputControl"
             (ionFocus)="unformatCurrency()"
             (ionBlur)="formatCurrency()"
             (ionInput)="applyMask($event.detail.value)">
  </ion-input>
  <!-- INPUT TEXTAREA -->
  <ion-textarea mode="ios" *ngIf="field.type === 'textarea' && field.visible" [formControl]="inputControl"
                [placeholder]="field.placeholder | translate" rows="4" [counter]="true" maxlength="160"></ion-textarea>
  <!-- INPUT SELECT -->
  <div *ngIf="field.type === 'select' && field.visible"
       class="select-container flex justify-between items-center relative w-full">
    <ion-select [placeholder]="field.placeholder | translate" [value]="inputControl.value" mode="ios" toggleIcon=""
                interface="action-sheet" [disabled]="disabled" (ionChange)="setSelection($event.detail.value)"
                cancelText="Cancelar" okText="Seleccionar" class="custom-select">
      <ion-select-option *ngFor="let option of field.options" [value]="option.value" class="select-interface-option">
        {{ option.label | translate }}
      </ion-select-option>
    </ion-select>
    <ion-icon src="../../../assets/svg/arrowDown.svg" class="absolute right-0 text-[17px] select-arrow-icon"
              color="secondary"></ion-icon>
  </div>
</div>
<!-- INPUT IMAGE -->
<div *ngIf="field.type === 'file' && field.visible" class="flex overflow-x-auto ml-4 gap-3 mt-2 pr-4 pb-2">
  <div *ngFor="let imageUrl of imageUrls; let i = index" [ngStyle]="{ 'background-image': 'url(' + imageUrl + ')' }"
       class="h-[64px] w-[67px] min-w-[67px] rounded-xl flex justify-center items-center !bg-center !bg-cover relative">
    <button class="absolute top-1 right-1 bg-white rounded-full w-6 h-6 flex justify-center items-center"
            (click)="removeImage(i)">
      <ion-icon name="trash-outline" color="danger"></ion-icon>
    </button>
  </div>
  <button class="h-[64px] w-[67px] min-w-[67px] bg-[#ebf6fb80] rounded-xl flex justify-center items-center"
          (click)="handleImageUpload()">
    <ion-icon src="'../../../assets/svg/plus2.svg" class="text-[#294d8fc5]"></ion-icon>
  </button>
</div>
<!-- INPUT ADDRESS -->
<button *ngIf="field.type === 'map' && field.visible"
        class="h-[64px] w-[67px] bg-[#ebf6fb80] rounded-xl flex justify-center items-center ml-4 mt-2"
        (click)="navigate('/map')">
  <ion-icon src="'../../../assets/svg/location2.svg" class="text-[#294d8fc5]"></ion-icon>
</button>
